<wbo-edit-page #editPage (saving)="saving($event)">
    <fui-rows>
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <fui-inline-warning [title]="'wbo.cash-management.edit.message.tillBalanced'" *ngIf="model.data.till.firstBalanceDate">
                    </fui-inline-warning>
                </fui-column>
            </fui-two-columns>
        </fui-row>
    </fui-rows>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.cash-management.edit.formation.details', formControlNames: ''}">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-column>
                    <ng-container formGroupName="till">
                        <wbo-text-edit-control formControlName="terminalName" [(ngModel)]="model.data.till.terminalName" [readonly]="true"></wbo-text-edit-control>
                    </ng-container>
                </fui-column>
            </fui-row>
            <fui-row>
                <fui-four-columns>
                    <fui-column>
                        <ng-container formGroupName="inRecUser">
                            <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.inRecUser.name" [readonly]="true"></wbo-text-edit-control>
                        </ng-container>
                    </fui-column>
                    <fui-column>
                        <ng-container formGroupName="till">
                            <wbo-text-edit-control [label]="'wbo.cash-management.edit.field.till.startTime.label'"
                                                   [placeholder]="'wbo.cash-management.edit.field.till.startTime.placeholder'"
                                                   [value]="model.data.till.startTime | wbo_date_time" [readonly]="true"></wbo-text-edit-control>
                        </ng-container>
                    </fui-column>
                    <fui-column>
                        <ng-container formGroupName="outRecUser">
                            <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.outRecUser.name" [readonly]="true"></wbo-text-edit-control>
                        </ng-container>
                    </fui-column>
                    <fui-column>
                        <ng-container formGroupName="till">
                            <wbo-text-edit-control [label]="'wbo.cash-management.edit.field.till.finishTime.label'"
                                                   [placeholder]="'wbo.cash-management.edit.field.till.finishTime.placeholder'"
                                                   [value]="model.data.till.finishTime | wbo_date_time" [readonly]="true"></wbo-text-edit-control>
                        </ng-container>
                    </fui-column>
                </fui-four-columns>
            </fui-row>
            <fui-row>
                <fui-four-columns>
                    <fui-column>
                        <ng-container formGroupName="till">
                            <ng-container formGroupName="firstRecUser">
                                <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.till.firstRecUser.name" [readonly]="true"></wbo-text-edit-control>
                            </ng-container>
                        </ng-container>
                    </fui-column>
                    <fui-column>
                        <ng-container formGroupName="till">
                            <wbo-text-edit-control [label]="'wbo.cash-management.edit.field.till.firstBalanceDate.label'"
                                                   [placeholder]="'wbo.cash-management.edit.field.till.firstBalanceDate.placeholder'"
                                                   [value]="model.data.till.firstBalanceDate | wbo_date_time" [readonly]="true"></wbo-text-edit-control>
                        </ng-container>
                    </fui-column>
                    <fui-column>
                        <ng-container formGroupName="till">
                            <ng-container formGroupName="recUser">
                                <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.till.recUser.name" [readonly]="true"></wbo-text-edit-control>
                            </ng-container>
                        </ng-container>
                    </fui-column>
                    <fui-column>
                        <ng-container formGroupName="till">
                            <wbo-text-edit-control [label]="'wbo.cash-management.edit.field.till.balanceDate.label'"
                                                   [placeholder]="'wbo.cash-management.edit.field.till.balanceDate.placeholder'"
                                                   [value]="model.data.till.balanceDate | wbo_date_time" [readonly]="true"></wbo-text-edit-control>
                        </ng-container>
                    </fui-column>
                </fui-four-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.cash-management.edit.formation.balanceTotals', formControlNames: ''}">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-currency-edit-control formControlName="floatIn" [(ngModel)]="model.data.floatIn"></wbo-currency-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-currency-edit-control formControlName="floatOut" [(ngModel)]="model.data.floatOut"></wbo-currency-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-column>
                    <wbo-edit-grid [data]="model.data.till.balancedTenders" [editable]="true" [removable]="false" [entityPath]="'till.balancedTenders'">
                        <wbo-text-column field="tender"></wbo-text-column>
                        <wbo-currency-column field="userTotal" [editable]="true"></wbo-currency-column>
                        <wbo-column title="wbo.cash-management.edit.column.till.balancedTenders.calc" [width]="30">
                            <ng-template cellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                <fui-action *ngIf="rowIndex == 0" (click)="openCalculator()">
                                    <fui-icon [height]="25" [icon]="'calculator'" [width]="25"></fui-icon>
                                </fui-action>
                            </ng-template>
                        </wbo-column>
                    </wbo-edit-grid>
                </fui-column>
            </fui-row>
            <fui-row>
                <fui-four-columns>
                    <fui-column>
                    </fui-column>
                    <fui-column>
                    </fui-column>
                    <fui-column>
                        <b [style.text-align]="'right'">{{'wbo.cash-management.edit.message.tenderTotal' | translate}}</b>
                    </fui-column>
                    <fui-column>
                        <b [style.text-align]="'right'">{{calculateTotal() | wbo_currency}}</b>
                    </fui-column>
                </fui-four-columns>
            </fui-row>
            <fui-row>
                <fui-four-columns>
                    <fui-column>
                    </fui-column>
                    <fui-column>
                    </fui-column>
                    <fui-column>
                        <b [style.text-align]="'right'">{{'wbo.cash-management.edit.message.eftposCashout' | translate}}</b>
                    </fui-column>
                    <fui-column>
                        <b [style.text-align]="'right'">{{model.data.till.cashout | wbo_currency}}</b>
                    </fui-column>
                </fui-four-columns>
            </fui-row>
            <fui-row>
                <fui-four-columns>
                    <fui-column>
                    </fui-column>
                    <fui-column>
                    </fui-column>
                    <fui-column>
                        <b [style.text-align]="'right'">{{'wbo.cash-management.edit.message.balanceTotal' | translate}}</b>
                    </fui-column>
                    <fui-column>
                        <b [style.text-align]="'right'">{{model.data.till.balanceTotal | wbo_currency}}</b>
                    </fui-column>
                </fui-four-columns>
            </fui-row>

        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
